import styles from '@/components/Account/BenchlingAuth/BenchlingLinkRequiredToast/BenchlingLinkRequiredToast.module.scss';
import { web as webRoute } from '@/support/route';
import { history } from '@/utils/history';
import { type FC } from 'react';
import { RiLinkM } from 'react-icons/ri';

interface BenchlingLinkRequiredToastProps {
  onDismiss?: () => void;
}

/**
 * Raised when a delegated Benchling action fails because the user has no usable link.
 *
 * Carries the user to their account screen rather than telling them where to go. Retrying the action
 * cannot help until they have consented, so an action is the only useful thing this toast can offer.
 */
const BenchlingLinkRequiredToast: FC<BenchlingLinkRequiredToastProps> = ({ onDismiss }) => {
  const goToAccount = (): void => {
    // Toast content renders outside the router - ToastContainer is a sibling of RouterProvider - so
    // Link and useNavigate are both unavailable here. history.push dispatches onto the event bus that
    // BrowserHistoryEventBridge listens to inside the tree, which is how non-component code navigates.
    history.push(webRoute('account'));
    onDismiss?.();
  };

  return (
    <div className="flex flex-column" data-testid="benchling-link-required-toast">
      <div className="mb1" data-testid="benchling-link-required-toast__label">
        <strong>Benchling account not linked</strong>
      </div>
      <span className="f6">In Vivo needs your permission before it can act on your behalf in Benchling.</span>
      <button
        type="button"
        className={styles.action}
        onClick={goToAccount}
        data-testid="benchling-link-required-toast__action"
      >
        <RiLinkM />
        Link your account
      </button>
    </div>
  );
};

export default BenchlingLinkRequiredToast;
